module.exports = __webpack_public_path__ + "assets/tx-circle-icon.b6a3764c.svg";